import { render, staticRenderFns } from "./CultureSection.vue?vue&type=template&id=4490387b&scoped=true&"
import script from "./CultureSection.vue?vue&type=script&lang=js&"
export * from "./CultureSection.vue?vue&type=script&lang=js&"
import style0 from "./CultureSection.vue?vue&type=style&index=0&id=4490387b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490387b",
  null
  
)

export default component.exports